<template>
  <div v-if="displayExcludedInfo" class="mx-2">
    <font-awesome-icon icon="exclamation-triangle"
                       class="text-md text-red" v-tooltip="{ content: excludedInfoText, classes: '--white' }"/>
  </div>
</template>

<script>
export default {
  name: "ExcludedInfo",
  props: {
    offBudget: {
      type: Boolean,
      required: true
    },
    offReport: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    displayExcludedInfo() {
      return this.offBudget || this.offReport
    },
    excludedInfoText() {
      if (!this.displayExcludedInfo) return;
      return this.offBudget && this.offReport
          ? this.$t('offReportAndBudget')
          : this.offReport
              ? this.$t('offReport')
              : this.$t('offBudget')
    }
  },
  i18n: {
    messages: {
      en: {
        offBudget: 'Excluded from budget',
        offReport: 'Excluded from reports',
        offReportAndBudget: 'Excluded from budget and reports'
      },
      ru: {
        offBudget: 'Исключена из бюджета',
        offReport: 'Исключена из отчетов',
        offReportAndBudget: 'Исключена из бюджета и отчетов'
      }
    }
  }
}
</script>

<style scoped>

</style>